import { assertUnreachable } from "@aderant/aderant-web-fw-core";
import React from "react";
import { formatShortDateDisplay } from "../../../Utils";
import { Messages } from "../../Messages";
import { compareRows as defaultCompareRows } from "../../types";
import { defaultMultiFilter } from "../../types/GridColumnProps";
/**
 * Gets the display value for the cell.
 * Supports default formatting for each of the @see GridCellValue types.
 */
export function getCellDisplayValue(cell) {
    if (cell === undefined || cell === null || cell === "") {
        return React.createElement("span", null, "-");
    }
    if (typeof cell === "string") {
        return React.createElement("span", null, cell);
    }
    if (typeof cell === "number") {
        return React.createElement("span", null, cell.toString());
    }
    if (cell instanceof Date) {
        return React.createElement("span", null, formatShortDateDisplay(cell));
    }
    if (typeof cell === "boolean") {
        const message = cell ? Messages.YES.getMessage() : Messages.NO.getMessage();
        return React.createElement("span", null, message);
    }
    assertUnreachable(cell);
}
export function getColumnDefinitionId(columnDefinition) {
    if (columnDefinition.id) {
        return columnDefinition.id;
    }
    else if (columnDefinition.path && typeof columnDefinition.path === "string") {
        return columnDefinition.path;
    }
    else {
        console.warn("Column id not found.");
        return "";
    }
}
// #region Convert column definitions to react-table column definitions
export const convertColumnDefinitions = (columnDefs, defaultCellDisplayValue) => {
    const columns = [];
    columnDefs.forEach(({ columnName, isVisible, isDataProperty, isGrouped, groupHeaderRow, path, allowSort, sortComparer, columns: defColumns, Cell, id, width, filter, ...other }) => {
        //The compiler won't let accessor accept a property that is of multiple types, hence the if statement below.
        let accessorObject;
        let pathString = "";
        if (path) {
            if (typeof path == "string") {
                pathString = path;
                accessorObject = { accessor: pathString };
            }
            else {
                const pathFunc = path;
                accessorObject = { accessor: pathFunc };
            }
        }
        else {
            accessorObject = { accessor: "" };
        }
        return columns.push({
            Cell: Cell ||
                ((cellProps) => {
                    return defaultCellDisplayValue(cellProps.cell.value);
                }),
            columns: defColumns && convertColumnDefinitions(defColumns, defaultCellDisplayValue),
            defaultCanFilter: true,
            disableSortBy: allowSort == false,
            sortType: sortComparer ?? defaultCompareRows,
            filter: filter ?? defaultMultiFilter,
            groupHeaderRow: groupHeaderRow,
            Header: columnName,
            id: id || pathString,
            isGrouped: isGrouped || false,
            isDataProperty: isDataProperty ?? true,
            isVisible: typeof isVisible !== "undefined" ? isVisible : true,
            pxWidth: width,
            ...accessorObject,
            ...other
        });
    });
    return columns;
};
// #endregion
